import { MotionEase } from './resolveMotionEase';

const linear: MotionEase = (value) => value;

export default function mapMotionProgress(
  value: number,
  start: number,
  end: number,
  ease: MotionEase = linear,
) {
  if (start === end) return value >= end ? 1 : 0;

  const progress = Math.min(1, Math.max(0, (value - start) / (end - start)));
  return ease(progress);
}
